module.exports = __webpack_public_path__ + "img/couponclass7rc5.4aca6f34.png";